import { Box, Checkbox, Spinner } from '@factorialco/deprecated-design-system'
import { EmployeeAssignManagerModalDataDocument } from 'generated/resources/graphql'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { useQuery } from 'modules/core/hooks/useQuery'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'
import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'

interface Props {
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: () => void
  onClick: () => void
  width: number
  formKey: 'manager_id' | 'timeoff_manager_id'
}

const ManagerCell = ({ bulkEditForm, isChecked, onChange, onClick, width, formKey }: Props) => {
  const selectedManagerId = bulkEditForm.get(formKey).value

  const { data: employeesData, loading } = useQuery(EmployeeAssignManagerModalDataDocument, {
    variables: {
      id: parseInt(selectedManagerId, 0),
    },
    skip: selectedManagerId.toString() === '',
  })

  const selectedManager = employeesData?.employees.employeeName

  if (loading) {
    return (
      <Box alignItems="center" paddingY="s16" style={{ width: `${width}px` }}>
        <Spinner />
      </Box>
    )
  }

  const handleSelect = (selectedEmployee: EmployeeForSelectFragmentNoAccess | null) => {
    if (!selectedEmployee) return

    bulkEditForm.setValues({
      [formKey]: selectedEmployee.id,
    })

    onChange()
  }

  const remainingWidth = width - 78

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width: `${width}px` }}
    >
      <Box flexNoShrink>
        <Checkbox checked={isChecked} onChange={onClick} />
      </Box>
      <Box style={{ width: `${remainingWidth}px` }}>
        <EmployeeSelector onSelect={handleSelect} value={selectedManager} hideSearchIcon />
      </Box>
    </Box>
  )
}

export default ManagerCell
